/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Partner_Org_Contract_Approve_EffectInputs */



/**
* | output |
* | --- |
* | "The organization becomes active on {date} and its prepaid contingent is credited then. Until that moment nobody there can sign in." |
*
* @param {Partner_Org_Contract_Approve_EffectInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_org_contract_approve_effect = /** @type {((inputs: Partner_Org_Contract_Approve_EffectInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Org_Contract_Approve_EffectInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Die Organisation wird am ${i?.date} aktiv und das vorausbezahlte Guthaben wird dann gutgeschrieben. Bis dahin kann sich dort niemand anmelden.`)
	return /** @type {LocalizedString} */ (`The organization becomes active on ${i?.date} and its prepaid contingent is credited then. Until that moment nobody there can sign in.`)
});